
import {Vue, Component, Prop} from 'vue-property-decorator';
import {IUser} from "@/model/User/UserInterface";

@Component({})
export default class UserStatus extends Vue {

  @Prop()
  user!: IUser

  get isRegistered(): boolean {
    return this.user.last_logged_in != null && this.user.hasPassword == true;
  }

  get isPackageReception(): boolean {
    return this.user.receivedPackageDelivery == true;
  }

  get isOrder(): boolean {
    return this.user.madeAnOrder == true;
  }
}
